import { Link } from "react-router-dom";
import { t } from "../lib/i18n";

export function NotFoundPage() {
  return (
    <div className="py-16 text-center">
      <h1 className="text-2xl font-bold">{t("Halaman tidak dijumpai")}</h1>
      <Link to="/" className="mt-4 inline-block text-brand underline">
        {t("Kembali ke laman utama")}
      </Link>
    </div>
  );
}
